/* @flow */
// typecheck: ignore file
import React from 'react';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';

import EventTracking, { getEventProperties } from 'lib/EventTracking';


const trackView = (Component: *, eventScreenName?: ?string, getEventPropertiesFromProps?: (props: Object) => Object) => {
  class WrappedComponent extends React.Component {
    static contextTypes = {
      eventProperties: React.PropTypes.object,
    };

    displayName = `TrackView(${Component.displayName})`;

    componentDidMount() {
      const screenName = eventScreenName || Component.displayName;
      invariant(screenName, 'TriggerViewEvent requires an eventScreenName, otherwise it would be the same as the automatically generated view event.');

      const eventPropertiesFromProps = getEventPropertiesFromProps ? getEventPropertiesFromProps(this.props) : {};
      const viewProperties = getEventProperties(eventPropertiesFromProps, this.context);
      EventTracking.view(screenName, viewProperties);
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  return hoistStatics(WrappedComponent, Component);
};

export default trackView;



// WEBPACK FOOTER //
// ./src/lib/trackView.js